import React, { useState, forwardRef, useImperativeHandle } from 'react';

import Box from '@material-ui/core/Box';
import Button from '@material-ui/core/Button';
import CircularProgress from '@material-ui/core/CircularProgress';
import { green } from '@material-ui/core/colors';
import Dialog from '@material-ui/core/Dialog';
import MuiDialogActions from '@material-ui/core/DialogActions';
import MuiDialogContent from '@material-ui/core/DialogContent';
import MuiDialogTitle from '@material-ui/core/DialogTitle';
import IconButton from '@material-ui/core/IconButton';
import Slide from '@material-ui/core/Slide';
import { withStyles, makeStyles } from '@material-ui/core/styles';
import Typography from '@material-ui/core/Typography';
import CloseIcon from '@material-ui/icons/Close';
import { useSnackbar } from 'notistack';

import { SwitchInput, PorcentagemInput } from '../../../Components';
import { updateAPI, getListAllAPI } from '../../../services';

const styles = (theme) => ({
  root: {
    margin: 0,
    padding: theme.spacing(2),
  },
  closeButton: {
    position: 'absolute',
    right: theme.spacing(1),
    top: theme.spacing(1),
    color: 'white',
  },
});

const Transition = React.forwardRef((props, ref) => (
  <Slide direction="up" ref={ref} {...props} />
));

const DialogTitle = withStyles(styles)((props) => {
  const { children, classes, onClose, ...other } = props;
  return (
    <MuiDialogTitle disableTypography className={classes.root} {...other}>
      <Typography variant="h6" style={{ fontWeight: 'bold' }}>
        {children}
      </Typography>
      {onClose ? (
        <IconButton
          aria-label="close"
          className={classes.closeButton}
          onClick={onClose}
        >
          <CloseIcon />
        </IconButton>
      ) : null}
    </MuiDialogTitle>
  );
});

const DialogContent = withStyles((theme) => ({
  root: {
    padding: theme.spacing(2),
  },
}))(MuiDialogContent);

const DialogActions = withStyles((theme) => ({
  root: {
    margin: 0,
    padding: theme.spacing(1),
  },
}))(MuiDialogActions);

const useStyles = makeStyles((theme) => ({
  rootDialogo: {
    borderRadius: '25px',
  },
  btnAtions: {
    borderRadius: '25px',
    width: '150px',
  },
  btnAtionsDisabled: {
    borderRadius: '25px',
    width: '150px',
  },
  wrapper: {
    margin: theme.spacing(1),
    position: 'relative',
  },
  buttonProgress: {
    color: green[500],
    position: 'absolute',
    top: '50%',
    left: '50%',
    marginTop: -12,
    marginLeft: -12,
  },
}));

const DialogoCategoriaTransacao = forwardRef(({ handleClose }, ref) => {
  const [open, setOpen] = useState(false);
  const { enqueueSnackbar } = useSnackbar();
  const [nome, setNome] = useState('');

  const [id, setId] = useState(-1);

  const [carregando, setCarregando] = useState(false);

  const [permitirCriacaoOfertas, setPermitirCriacaoOfertas] = useState(true);
  const [permitirCriacaoLiberacoes, setPermitirCriacaoLiberacoes] = useState(
    true,
  );
  const [descontoMaximoPrecoVenda, setDescontoMaximoPrecoVenda] = useState(0);

  const classes = useStyles({ cor: '#009FD4' });

  const handleCloseDialog = () => {
    setOpen(false);
    handleClose();
  };

  async function reiniciar() {
    setId(-1);
    setNome('');
    setCarregando(false);
  }

  async function getDataResource(id) {
    try {
      const data = await getListAllAPI(
        'configuracoes_produtos',
        ['id', 'asc'],
        { id: [id] },
        [],
      );
      if (data.data.length > 0) {
        setId(data.data[0].id);
        setNome(data.data[0].nome);
        setPermitirCriacaoOfertas(
          data.data[0].permitir_criacao_ofertas ? true : false,
        );
        setPermitirCriacaoLiberacoes(
          data.data[0].permitir_criacao_liberacoes ? true : false,
        );
        setDescontoMaximoPrecoVenda(data.data[0].desconto_maximo_preco_venda);
        setCarregando(false);
      } else {
        throw 'Esta feature não existe!';
      }
    } catch (erros) {
      enqueueSnackbar(`${erros}`, {
        variant: 'error',
      });
      handleCloseDialog();
    }
  }

  async function handleSalvar() {
    setCarregando(true);
    try {
      if (id <= 0) {
        setCarregando(false);
        enqueueSnackbar('Erro aqui!', {
          variant: 'success',
        });
      } else {
        await updateAPI('configuracoes_produtos', id, {
          permitir_criacao_ofertas: permitirCriacaoOfertas,
          permitir_criacao_liberacoes: permitirCriacaoLiberacoes,
          desconto_maximo_preco_venda: descontoMaximoPrecoVenda,
        });
        setCarregando(false);
        enqueueSnackbar(
          `Configurações do produto '${nome}' atualizadas com sucesso!`,
          {
            variant: 'success',
          },
        );
      }

      handleCloseDialog();
    } catch (erros) {
      enqueueSnackbar(`${erros}`, {
        variant: 'error',
      });
      handleCloseDialog();
    }
  }

  useImperativeHandle(ref, () => ({
    handleOpen(id) {
      setCarregando(true);
      getDataResource(id);
      setId(id);
      setOpen(true);
    },
  }));

  function validateDescontoMaximo() {
    let error = '';
    if (
      descontoMaximoPrecoVenda < 0 ||
      Number.isNaN(descontoMaximoPrecoVenda)
    ) {
      error = 'Este campo é obrigatório!';
    }
    return error;
  }

  function getErros() {
    const errosOld = ['', ''];
    errosOld[0] = validateDescontoMaximo();
    return errosOld;
  }

  const erros = getErros();

  function hasError() {
    for (let i = 0; i < erros.length; i += 1) {
      if (erros[i] !== '') return true;
    }
    return false;
  }

  const erroExistente = hasError();

  const marginLine = 2;

  return (
    <div>
      <Dialog
        open={open}
        aria-labelledby="form-dialog-title"
        classes={{ paper: classes.rootDialogo }}
        className={classes.rootDialogo}
        fullWidth
        maxWidth="md"
        TransitionComponent={Transition}
        keepMounted
      >
        <DialogTitle
          id="form-dialog-title"
          onClose={handleCloseDialog}
          style={{ backgroundColor: '#009FD4', color: 'white' }}
        >
          {id < 0
            ? `Algo está errado`
            : `Editar Configurações Produto: ${nome} (id = ${id})`}
        </DialogTitle>
        <DialogContent
          style={{
            padding: '0px 36px 20px',
            margin: '0',
          }}
        >
          {carregando ? (
            <div
              style={{
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center',
              }}
            >
              <CircularProgress />
            </div>
          ) : (
            <div>
              <Box flex={1}>
                <SwitchInput
                  name="permitir_criacao_ofertas"
                  handleEnter={() => {}}
                  label="Permitir de Criação de Ofertas"
                  handleKey={() => {}}
                  checked={permitirCriacaoOfertas}
                  onChange={(value) =>
                    setPermitirCriacaoOfertas(value.target.checked)
                  }
                  fullWidth
                />
              </Box>
              <Box flex={1}>
                <SwitchInput
                  name="permitir_criacao_liberacoes"
                  handleEnter={() => {}}
                  label="Permitir de Criação de Liberações de Preços"
                  handleKey={() => {}}
                  checked={permitirCriacaoLiberacoes}
                  onChange={(value) =>
                    setPermitirCriacaoLiberacoes(value.target.checked)
                  }
                  fullWidth
                />
              </Box>
              <Box flex={1}>
                <PorcentagemInput
                  fullWidth
                  source="pis"
                  label="Desconto Máximo (%)"
                  error={erros[0] !== ''}
                  helperText={erros[0]}
                  handleEnter={() => {}}
                  handleKey={() => {}}
                  value={
                    Number.isNaN(descontoMaximoPrecoVenda)
                      ? ''
                      : String(descontoMaximoPrecoVenda)
                  }
                  onChange={(value) =>
                    setDescontoMaximoPrecoVenda(parseFloat(value.target.value))
                  }
                />
              </Box>
            </div>
          )}
        </DialogContent>
        <DialogActions
          style={{
            padding: '0px 36px 20px',
            margin: '0',
          }}
        >
          <div className={classes.wrapper}>
            <Button
              onClick={handleSalvar}
              classes={{
                root: classes.btnAtions,
                disabled: classes.btnAtionsDisabled,
              }}
              disabled={erroExistente || carregando}
              variant="contained"
              color="primary"
            >
              Salvar
            </Button>
            {carregando && (
              <CircularProgress size={24} className={classes.buttonProgress} />
            )}
          </div>
        </DialogActions>
      </Dialog>
    </div>
  );
});

export default DialogoCategoriaTransacao;
